import type { DesignFinishingReviewType } from '@orthly/dentin';

export const TYPE_TO_TITLE: Readonly<Record<DesignFinishingReviewType, string>> = Object.freeze({
    occlusion: 'Contours and occlusion',
    insertion: 'Insertion direction',
    mesial: 'Mesial contact',
    distal: 'Distal contact',
});
